"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * guest-widgets-editor-backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetsApi = exports.WidgetsApiFactory = exports.WidgetsApiFp = exports.WidgetsApiAxiosParamCreator = exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.ProductsApi = exports.ProductsApiFactory = exports.ProductsApiFp = exports.ProductsApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.DebugApi = exports.DebugApiFactory = exports.DebugApiFp = exports.DebugApiAxiosParamCreator = exports.ConfigurationsApi = exports.ConfigurationsApiFactory = exports.ConfigurationsApiFp = exports.ConfigurationsApiAxiosParamCreator = exports.CategoriesApi = exports.CategoriesApiFactory = exports.CategoriesApiFp = exports.CategoriesApiAxiosParamCreator = exports.WidgetTypeDto = exports.WidgetButtonTypeDto = exports.ToggleFeatureDto = exports.LocaleDto = exports.FloatingPosition = exports.CategorySortDto = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
var CategorySortDto;
(function (CategorySortDto) {
    CategorySortDto["Name"] = "name";
    CategorySortDto["Name2"] = "-name";
})(CategorySortDto = exports.CategorySortDto || (exports.CategorySortDto = {}));
/**
 *
 * @export
 * @enum {string}
 */
var FloatingPosition;
(function (FloatingPosition) {
    FloatingPosition["BottomRight"] = "BottomRight";
    FloatingPosition["MiddleRight"] = "MiddleRight";
})(FloatingPosition = exports.FloatingPosition || (exports.FloatingPosition = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LocaleDto;
(function (LocaleDto) {
    LocaleDto["ArAe"] = "ar_AE";
    LocaleDto["BgBg"] = "bg_BG";
    LocaleDto["CaEs"] = "ca_ES";
    LocaleDto["CsCz"] = "cs_CZ";
    LocaleDto["DaDk"] = "da_DK";
    LocaleDto["DeAt"] = "de_AT";
    LocaleDto["DeCh"] = "de_CH";
    LocaleDto["DeDe"] = "de_DE";
    LocaleDto["DeLi"] = "de_LI";
    LocaleDto["DeLu"] = "de_LU";
    LocaleDto["ElCy"] = "el_CY";
    LocaleDto["ElGr"] = "el_GR";
    LocaleDto["EnAu"] = "en_AU";
    LocaleDto["EnCa"] = "en_CA";
    LocaleDto["EnGb"] = "en_GB";
    LocaleDto["EnIe"] = "en_IE";
    LocaleDto["EnMt"] = "en_MT";
    LocaleDto["EnNz"] = "en_NZ";
    LocaleDto["EnUs"] = "en_US";
    LocaleDto["EnZa"] = "en_ZA";
    LocaleDto["EsCr"] = "es_CR";
    LocaleDto["EsEs"] = "es_ES";
    LocaleDto["EsMx"] = "es_MX";
    LocaleDto["EsPr"] = "es_PR";
    LocaleDto["EtEe"] = "et_EE";
    LocaleDto["FiFi"] = "fi_FI";
    LocaleDto["FilPh"] = "fil_PH";
    LocaleDto["FrBe"] = "fr_BE";
    LocaleDto["FrCa"] = "fr_CA";
    LocaleDto["FrCh"] = "fr_CH";
    LocaleDto["FrFr"] = "fr_FR";
    LocaleDto["FrLu"] = "fr_LU";
    LocaleDto["HeIl"] = "he_IL";
    LocaleDto["HrHr"] = "hr_HR";
    LocaleDto["HuHu"] = "hu_HU";
    LocaleDto["ItCh"] = "it_CH";
    LocaleDto["ItIt"] = "it_IT";
    LocaleDto["JaJp"] = "ja_JP";
    LocaleDto["LtLt"] = "lt_LT";
    LocaleDto["LvLv"] = "lv_LV";
    LocaleDto["MsMy"] = "ms_MY";
    LocaleDto["MtMt"] = "mt_MT";
    LocaleDto["NlBe"] = "nl_BE";
    LocaleDto["NlLu"] = "nl_LU";
    LocaleDto["NlNl"] = "nl_NL";
    LocaleDto["NoNo"] = "no_NO";
    LocaleDto["PlPl"] = "pl_PL";
    LocaleDto["PtPt"] = "pt_PT";
    LocaleDto["RoRo"] = "ro_RO";
    LocaleDto["SkSk"] = "sk_SK";
    LocaleDto["SlSi"] = "sl_SI";
    LocaleDto["SvSe"] = "sv_SE";
    LocaleDto["TrTr"] = "tr_TR";
    LocaleDto["ZhCn"] = "zh_CN";
    LocaleDto["ZhHansHk"] = "zh_Hans_HK";
    LocaleDto["ZhHantHk"] = "zh_Hant_HK";
})(LocaleDto = exports.LocaleDto || (exports.LocaleDto = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ToggleFeatureDto;
(function (ToggleFeatureDto) {
    ToggleFeatureDto["CalendarBlock"] = "calendar-block";
    ToggleFeatureDto["RemainingTickets"] = "remaining-tickets";
    ToggleFeatureDto["BackToTop"] = "back-to-top";
    ToggleFeatureDto["MiscellaneousFilter"] = "miscellaneous-filter";
    ToggleFeatureDto["LanguageFilter"] = "language-filter";
    ToggleFeatureDto["ProductSorting"] = "product-sorting";
    ToggleFeatureDto["PriceFilter"] = "price-filter";
    ToggleFeatureDto["MoreFilter"] = "more-filter";
    ToggleFeatureDto["CategoryFilter"] = "category-filter";
    ToggleFeatureDto["LocationFilter"] = "location-filter";
    ToggleFeatureDto["DateFilter"] = "date-filter";
    ToggleFeatureDto["ShowInactiveProducts"] = "show-inactive-products";
    ToggleFeatureDto["RequiresDateFilter"] = "requires-date-filter";
    ToggleFeatureDto["Tripadvisor"] = "tripadvisor";
    ToggleFeatureDto["DescriptionBlock"] = "description-block";
    ToggleFeatureDto["ShowDescription"] = "show-description";
    ToggleFeatureDto["LongDescription"] = "long-description";
    ToggleFeatureDto["Tags"] = "tags";
    ToggleFeatureDto["InformationBlock"] = "information-block";
    ToggleFeatureDto["InfoCovid"] = "info-covid";
    ToggleFeatureDto["InfoIncluded"] = "info-included";
    ToggleFeatureDto["InfoBringWithYou"] = "info-bring-with-you";
    ToggleFeatureDto["InfoParticipants"] = "info-participants";
    ToggleFeatureDto["InfoLanguages"] = "info-languages";
    ToggleFeatureDto["InfoOpeningHours"] = "info-opening-hours";
    ToggleFeatureDto["InfoRequirements"] = "info-requirements";
    ToggleFeatureDto["InfoImportantInformation"] = "info-important-information";
    ToggleFeatureDto["InfoAdditional"] = "info-additional";
    ToggleFeatureDto["Location"] = "location";
    ToggleFeatureDto["RatingAndReview"] = "rating-and-review";
    ToggleFeatureDto["CrossSelling"] = "cross-selling";
    ToggleFeatureDto["RegiondoLogo"] = "regiondo-logo";
    ToggleFeatureDto["ProductLocation"] = "product-location";
    ToggleFeatureDto["ProductDuration"] = "product-duration";
    ToggleFeatureDto["ProductRating"] = "product-rating";
    ToggleFeatureDto["ProductPrice"] = "product-price";
    ToggleFeatureDto["ProductButton"] = "product-button";
})(ToggleFeatureDto = exports.ToggleFeatureDto || (exports.ToggleFeatureDto = {}));
/**
 *
 * @export
 * @enum {string}
 */
var WidgetButtonTypeDto;
(function (WidgetButtonTypeDto) {
    WidgetButtonTypeDto["Catalog"] = "Catalog";
    WidgetButtonTypeDto["Product"] = "Product";
    WidgetButtonTypeDto["Booking"] = "Booking";
})(WidgetButtonTypeDto = exports.WidgetButtonTypeDto || (exports.WidgetButtonTypeDto = {}));
/**
 *
 * @export
 * @enum {string}
 */
var WidgetTypeDto;
(function (WidgetTypeDto) {
    WidgetTypeDto["Catalog"] = "Catalog";
    WidgetTypeDto["Product"] = "Product";
    WidgetTypeDto["Booking"] = "Booking";
    WidgetTypeDto["Button"] = "Button";
    WidgetTypeDto["Calendar"] = "Calendar";
})(WidgetTypeDto = exports.WidgetTypeDto || (exports.WidgetTypeDto = {}));
/**
 * CategoriesApi - axios parameter creator
 * @export
 */
const CategoriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {boolean} [populated] When populated is true, the response will include only categories populated with at list one product.
         * @param {CategorySortDto} [sort]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (populated, sort, limit, offset, options = {}) => {
            const localVarPath = `/api/v1/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (populated !== undefined) {
                localVarQueryParameter['populated'] = populated;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CategoriesApiAxiosParamCreator = CategoriesApiAxiosParamCreator;
/**
 * CategoriesApi - functional programming interface
 * @export
 */
const CategoriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CategoriesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {boolean} [populated] When populated is true, the response will include only categories populated with at list one product.
         * @param {CategorySortDto} [sort]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(populated, sort, limit, offset, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(populated, sort, limit, offset, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CategoriesApi.getCategories']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.CategoriesApiFp = CategoriesApiFp;
/**
 * CategoriesApi - factory interface
 * @export
 */
const CategoriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CategoriesApiFp)(configuration);
    return {
        /**
         *
         * @param {CategoriesApiGetCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(requestParameters = {}, options) {
            return localVarFp.getCategories(requestParameters.populated, requestParameters.sort, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CategoriesApiFactory = CategoriesApiFactory;
/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
class CategoriesApi extends base_1.BaseAPI {
    /**
     *
     * @param {CategoriesApiGetCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    getCategories(requestParameters = {}, options) {
        return (0, exports.CategoriesApiFp)(this.configuration).getCategories(requestParameters.populated, requestParameters.sort, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CategoriesApi = CategoriesApi;
/**
 * ConfigurationsApi - axios parameter creator
 * @export
 */
const ConfigurationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('_delete', 'id', id);
            const localVarPath = `/api/v1/configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateConfigurationDto} createConfigurationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createConfigurationDto, options = {}) => {
            // verify required parameter 'createConfigurationDto' is not null or undefined
            (0, common_1.assertParamExists)('create', 'createConfigurationDto', createConfigurationDto);
            const localVarPath = `/api/v1/configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createConfigurationDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options = {}) => {
            const localVarPath = `/api/v1/configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('findById', 'id', id);
            const localVarPath = `/api/v1/configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publish: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('publish', 'id', id);
            const localVarPath = `/api/v1/configurations/{id}/publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {UpdateConfigurationDto} updateConfigurationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id, updateConfigurationDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('update', 'id', id);
            // verify required parameter 'updateConfigurationDto' is not null or undefined
            (0, common_1.assertParamExists)('update', 'updateConfigurationDto', updateConfigurationDto);
            const localVarPath = `/api/v1/configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateConfigurationDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ConfigurationsApiAxiosParamCreator = ConfigurationsApiAxiosParamCreator;
/**
 * ConfigurationsApi - functional programming interface
 * @export
 */
const ConfigurationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ConfigurationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ConfigurationsApi._delete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CreateConfigurationDto} createConfigurationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createConfigurationDto, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createConfigurationDto, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ConfigurationsApi.create']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ConfigurationsApi.findAll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findById(id, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findById(id, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ConfigurationsApi.findById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publish(id, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.publish(id, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ConfigurationsApi.publish']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {UpdateConfigurationDto} updateConfigurationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id, updateConfigurationDto, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, updateConfigurationDto, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ConfigurationsApi.update']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.ConfigurationsApiFp = ConfigurationsApiFp;
/**
 * ConfigurationsApi - factory interface
 * @export
 */
const ConfigurationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ConfigurationsApiFp)(configuration);
    return {
        /**
         *
         * @param {ConfigurationsApiDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(requestParameters, options) {
            return localVarFp._delete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ConfigurationsApiCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(requestParameters, options) {
            return localVarFp.create(requestParameters.createConfigurationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options) {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ConfigurationsApiFindByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById(requestParameters, options) {
            return localVarFp.findById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ConfigurationsApiPublishRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publish(requestParameters, options) {
            return localVarFp.publish(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ConfigurationsApiUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(requestParameters, options) {
            return localVarFp.update(requestParameters.id, requestParameters.updateConfigurationDto, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ConfigurationsApiFactory = ConfigurationsApiFactory;
/**
 * ConfigurationsApi - object-oriented interface
 * @export
 * @class ConfigurationsApi
 * @extends {BaseAPI}
 */
class ConfigurationsApi extends base_1.BaseAPI {
    /**
     *
     * @param {ConfigurationsApiDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsApi
     */
    _delete(requestParameters, options) {
        return (0, exports.ConfigurationsApiFp)(this.configuration)._delete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ConfigurationsApiCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsApi
     */
    create(requestParameters, options) {
        return (0, exports.ConfigurationsApiFp)(this.configuration).create(requestParameters.createConfigurationDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsApi
     */
    findAll(options) {
        return (0, exports.ConfigurationsApiFp)(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ConfigurationsApiFindByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsApi
     */
    findById(requestParameters, options) {
        return (0, exports.ConfigurationsApiFp)(this.configuration).findById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ConfigurationsApiPublishRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsApi
     */
    publish(requestParameters, options) {
        return (0, exports.ConfigurationsApiFp)(this.configuration).publish(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ConfigurationsApiUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationsApi
     */
    update(requestParameters, options) {
        return (0, exports.ConfigurationsApiFp)(this.configuration).update(requestParameters.id, requestParameters.updateConfigurationDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ConfigurationsApi = ConfigurationsApi;
/**
 * DebugApi - axios parameter creator
 * @export
 */
const DebugApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debug: async (options = {}) => {
            const localVarPath = `/api/api/v1/debug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DebugApiAxiosParamCreator = DebugApiAxiosParamCreator;
/**
 * DebugApi - functional programming interface
 * @export
 */
const DebugApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DebugApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debug(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.debug(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DebugApi.debug']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DebugApiFp = DebugApiFp;
/**
 * DebugApi - factory interface
 * @export
 */
const DebugApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DebugApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debug(options) {
            return localVarFp.debug(options).then((request) => request(axios, basePath));
        },
    };
};
exports.DebugApiFactory = DebugApiFactory;
/**
 * DebugApi - object-oriented interface
 * @export
 * @class DebugApi
 * @extends {BaseAPI}
 */
class DebugApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebugApi
     */
    debug(options) {
        return (0, exports.DebugApiFp)(this.configuration).debug(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DebugApi = DebugApi;
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveness: async (options = {}) => {
            const localVarPath = `/api/livez`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readiness: async (options = {}) => {
            const localVarPath = `/api/readyz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async liveness(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.liveness(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.liveness']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readiness(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.readiness(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.readiness']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liveness(options) {
            return localVarFp.liveness(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readiness(options) {
            return localVarFp.readiness(options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    liveness(options) {
        return (0, exports.DefaultApiFp)(this.configuration).liveness(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    readiness(options) {
        return (0, exports.DefaultApiFp)(this.configuration).readiness(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
/**
 * ProductsApi - axios parameter creator
 * @export
 */
const ProductsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {boolean} [includeInactive]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {string} [keyword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (includeInactive, dateFrom, dateTo, limit, offset, keyword, options = {}) => {
            const localVarPath = `/api/v1/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeInactive !== undefined) {
                localVarQueryParameter['includeInactive'] = includeInactive;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ProductsApiAxiosParamCreator = ProductsApiAxiosParamCreator;
/**
 * ProductsApi - functional programming interface
 * @export
 */
const ProductsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ProductsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {boolean} [includeInactive]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {number} [limit]
         * @param {number} [offset]
         * @param {string} [keyword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(includeInactive, dateFrom, dateTo, limit, offset, keyword, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(includeInactive, dateFrom, dateTo, limit, offset, keyword, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ProductsApi.findAll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.ProductsApiFp = ProductsApiFp;
/**
 * ProductsApi - factory interface
 * @export
 */
const ProductsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ProductsApiFp)(configuration);
    return {
        /**
         *
         * @param {ProductsApiFindAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(requestParameters = {}, options) {
            return localVarFp.findAll(requestParameters.includeInactive, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.limit, requestParameters.offset, requestParameters.keyword, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ProductsApiFactory = ProductsApiFactory;
/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
class ProductsApi extends base_1.BaseAPI {
    /**
     *
     * @param {ProductsApiFindAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    findAll(requestParameters = {}, options) {
        return (0, exports.ProductsApiFp)(this.configuration).findAll(requestParameters.includeInactive, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.limit, requestParameters.offset, requestParameters.keyword, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ProductsApi = ProductsApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
const UserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options = {}) => {
            const localVarPath = `/api/v1/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options = {}) => {
            const localVarPath = `/api/v1/user/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
const UserApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.getCurrentUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.logout']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
const UserApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UserApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options) {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
class UserApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    getCurrentUser(options) {
        return (0, exports.UserApiFp)(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    logout(options) {
        return (0, exports.UserApiFp)(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserApi = UserApi;
/**
 * WidgetsApi - axios parameter creator
 * @export
 */
const WidgetsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('_delete', 'id', id);
            const localVarPath = `/api/v1/widgets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {CreateWidgetDto} createWidgetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidget: async (createWidgetDto, options = {}) => {
            // verify required parameter 'createWidgetDto' is not null or undefined
            (0, common_1.assertParamExists)('createWidget', 'createWidgetDto', createWidgetDto);
            const localVarPath = `/api/v1/widgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createWidgetDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (options = {}) => {
            const localVarPath = `/api/v1/widgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('findById', 'id', id);
            const localVarPath = `/api/v1/widgets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetConfiguration: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getWidgetConfiguration', 'id', id);
            const localVarPath = `/api/v1/widgets/{id}/configuration`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {UpdateWidgetDto} updateWidgetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWidget: async (id, updateWidgetDto, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('updateWidget', 'id', id);
            // verify required parameter 'updateWidgetDto' is not null or undefined
            (0, common_1.assertParamExists)('updateWidget', 'updateWidgetDto', updateWidgetDto);
            const localVarPath = `/api/v1/widgets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateWidgetDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.WidgetsApiAxiosParamCreator = WidgetsApiAxiosParamCreator;
/**
 * WidgetsApi - functional programming interface
 * @export
 */
const WidgetsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.WidgetsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WidgetsApi._delete']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {CreateWidgetDto} createWidgetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWidget(createWidgetDto, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWidget(createWidgetDto, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WidgetsApi.createWidget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WidgetsApi.findAll']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findById(id, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.findById(id, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WidgetsApi.findById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWidgetConfiguration(id, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWidgetConfiguration(id, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WidgetsApi.getWidgetConfiguration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id UUID v4
         * @param {UpdateWidgetDto} updateWidgetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWidget(id, updateWidgetDto, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWidget(id, updateWidgetDto, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['WidgetsApi.updateWidget']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.WidgetsApiFp = WidgetsApiFp;
/**
 * WidgetsApi - factory interface
 * @export
 */
const WidgetsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.WidgetsApiFp)(configuration);
    return {
        /**
         *
         * @param {WidgetsApiDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(requestParameters, options) {
            return localVarFp._delete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WidgetsApiCreateWidgetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWidget(requestParameters, options) {
            return localVarFp.createWidget(requestParameters.createWidgetDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(options) {
            return localVarFp.findAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WidgetsApiFindByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findById(requestParameters, options) {
            return localVarFp.findById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WidgetsApiGetWidgetConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidgetConfiguration(requestParameters, options) {
            return localVarFp.getWidgetConfiguration(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {WidgetsApiUpdateWidgetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWidget(requestParameters, options) {
            return localVarFp.updateWidget(requestParameters.id, requestParameters.updateWidgetDto, options).then((request) => request(axios, basePath));
        },
    };
};
exports.WidgetsApiFactory = WidgetsApiFactory;
/**
 * WidgetsApi - object-oriented interface
 * @export
 * @class WidgetsApi
 * @extends {BaseAPI}
 */
class WidgetsApi extends base_1.BaseAPI {
    /**
     *
     * @param {WidgetsApiDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    _delete(requestParameters, options) {
        return (0, exports.WidgetsApiFp)(this.configuration)._delete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WidgetsApiCreateWidgetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    createWidget(requestParameters, options) {
        return (0, exports.WidgetsApiFp)(this.configuration).createWidget(requestParameters.createWidgetDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    findAll(options) {
        return (0, exports.WidgetsApiFp)(this.configuration).findAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WidgetsApiFindByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    findById(requestParameters, options) {
        return (0, exports.WidgetsApiFp)(this.configuration).findById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WidgetsApiGetWidgetConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    getWidgetConfiguration(requestParameters, options) {
        return (0, exports.WidgetsApiFp)(this.configuration).getWidgetConfiguration(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WidgetsApiUpdateWidgetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetsApi
     */
    updateWidget(requestParameters, options) {
        return (0, exports.WidgetsApiFp)(this.configuration).updateWidget(requestParameters.id, requestParameters.updateWidgetDto, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WidgetsApi = WidgetsApi;
//# sourceMappingURL=api.js.map